import { Modal as MuiModal, Paper } from "@mui/material";
import type { ReactElement } from "react";

export interface IModalProps {
  open: boolean;
  onClose: () => void;
}

interface IProps extends IModalProps {
  children: React.ReactNode;
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
  maxHeight: "80vh",
  overflow: "scroll",
};
export const Modal = ({ children, open, onClose }: IProps): ReactElement => {
  return (
    <MuiModal open={open} onClose={onClose}>
      <Paper elevation={5} sx={style}>
        {children}
      </Paper>
    </MuiModal>
  );
};
